export default "__VITE_ASSET__9an1YEOA__"